import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { UploadCloudIcon } from 'lucide-react';
interface DocumentUploaderProps {
  onUpload: (files: File[]) => void;
}
export function DocumentUploader({
  onUpload
}: DocumentUploaderProps) {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    onUpload(acceptedFiles);
  }, [onUpload]);
  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png']
    }
  });
  return <div {...getRootProps()} className={`border-2 border-dashed rounded-md p-6 text-center cursor-pointer transition-colors duration-200 ${isDragActive ? 'border-primary-500 bg-primary-50' : 'border-neutral-300 hover:border-primary-400'}`} data-id="element-267">
      <input {...getInputProps()} data-id="element-268" />
      <div className="flex flex-col items-center" data-id="element-269">
        <UploadCloudIcon className={`h-12 w-12 mb-3 ${isDragActive ? 'text-primary-500' : 'text-neutral-400'}`} data-id="element-270" />
        <p className="text-base font-medium text-neutral-900" data-id="element-271">
          {isDragActive ? 'Drop files here' : 'Upload documents'}
        </p>
        <p className="mt-1 text-sm text-neutral-500" data-id="element-272">
          Drag and drop files here, or click to browse
        </p>
        <p className="mt-1 text-xs text-neutral-400" data-id="element-273">
          Supports PDF, JPG, and PNG files
        </p>
      </div>
    </div>;
}